module.exports = __webpack_public_path__ + "static/img/superhouse-logo.cff325b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/superhouse-logo.png
// module id = eJaO
// module chunks = 1